import React, { useEffect, useState } from "react";
import "./Performance.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Nav, Tab, Tabs } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEllipsisVertical,
  faFilter,
  faSortDown,
  faSortUp,
} from "@fortawesome/free-solid-svg-icons";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import White_Btn from "../../common_components/common_btn/white_btn/White_Btn";
import Select, { components } from "react-select";
import Summary from "./summary/Summary";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import OrderHistory from "./orderhistory/OrderHistory";
import { getPerformanceSummary } from "../../../utils/apis/performance/performance";

const Performance = () => {
  const [key, setKey] = useState("Summary");

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon icon={faSortDown} className="custom_dropdown_icon" />
      </components.DropdownIndicator>
    );
  };

  return (
    <section className="Performance">
      <div className="header_div">
        <Section_Header_Bar />
      </div>

      <p className="section_title">Performance</p>

      <div className="inner_section_box">
        <div className="inner_box">
          <div className="inner_tab_content">
            <Tab.Container
              id="left-tabs-example"
              activeKey={key}
              onSelect={(key) => setKey(key)}
            >
              <div>
                <div className="col-12">
                  <Nav variant="pills" className=" " fill>
                    <div className="tabs_holder">
                      <Nav.Item>
                        <Nav.Link to={"/"} eventKey="Summary">
                          Summary
                        </Nav.Link>
                      </Nav.Item>

                      <Nav.Item>
                        <Nav.Link
                          to={"/services-inner/2"}
                          eventKey="History_Of_Orders"
                        >
                          History Of Orders
                        </Nav.Link>
                      </Nav.Item>
                    </div>
                  </Nav>
                </div>
                <div>
                  <Tab.Content>
                    <Tab.Pane eventKey="Summary">
                      <Summary />
                    </Tab.Pane>

                    <Tab.Pane eventKey="History_Of_Orders">
                      <OrderHistory />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </div>
            </Tab.Container>
          </div>
        </div>

        <div className="footer_text">
          <Inner_Footer_Text_Component />
        </div>
      </div>
    </section>
  );
};

export default Performance;
